export class UpdateUserRequest {
  constructor(
    public email: string,
    public gender: string,
    public language: string,
    public firstName: string,
    public lastName: string,
    public profession: string,
    public specialty: string,

    public country: string,
    public city: string,
    public postCode: string,
    public boxNumber: string,
    public box: string,
    public address: string,
    public phone: string,
    public mobile: string,

    public iban: string,
    public professionalNumber: string,
    public companyName: string,
    public companyNumber: string,
    public birthDate: string,
    public externalIdentifier: string,

  ) {}
}
